import { render } from "./CenterflowSettlementRatesModal.vue?vue&type=template&id=37bc5766&scoped=true"
import script from "./CenterflowSettlementRatesModal.vue?vue&type=script&lang=js"
export * from "./CenterflowSettlementRatesModal.vue?vue&type=script&lang=js"

import "./CenterflowSettlementRatesModal.vue?vue&type=style&index=0&id=37bc5766&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bc5766"]])

export default __exports__